module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('tooltip', {
    attrs: {
      "label": "View",
      "type": "default",
      "placement": "right"
    }
  }, [_c('a', {
    staticClass: "button is-small",
    on: {
      "click": function($event) {
        return _vm.url(this.data)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  })])]), _vm._v(" "), _c('tooltip', {
    attrs: {
      "label": "Move",
      "type": "default",
      "placement": "right"
    }
  }, [_c('a', {
    staticClass: "button is-small",
    on: {
      "click": function($event) {
        return _vm.move(this.data)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share"
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c3c936c2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/finances/V2/RefundsPaymentTableButtons.vue
// module id = 1191
// module chunks = 39